import React, {ReactNode} from "react";

export function MonoText(props: { children: ReactNode }) {
    return <span style={{fontFamily: 'monospace'}}>{props.children}</span>;
}